<script>
import Employee from "@/components/modals/employee-hris.vue";
import Location from "@/components/modals/property-location.vue";
export default {
    name: "IcfModal",
    components: {
        Employee,
        Location
    },
    computed: {
        isICFEmployee(){
            if(this.printOpts == 2){
                return true;
            }
            if(this.printOpts == 3){
                return true;
            }
            if(this.printOpts == 5){
                return true;
            }
            if(this.printOpts == 6){
                return true;
            }
            return false;
        },
        hasNoEmployeeSelected(){
            if(this.employeeId == "" || this.employeeId == null){
                return true;
            }
            return false;
        },
        hasNoLocationSelected(){
            if(this.locationId == "" || this.locationId == null){
                return true;
            }
            return false;
        }
    },
    data() {
        return {
            printOpts: "1",
            employeeName: "",
            employeeId: "",
            locationName: "",
            locationId: "",
            submitted: false
        }
    },
    methods: {
        getEmployee() {
            this.$refs.employee.resetData();
            this.$bvModal.show("icf-employee");
        },
        dropEmployee(data) {
            this.employeeId = data.idNo;
            this.employeeName = `${data.firstName} ${data.lastName}`;
            this.$bvModal.hide("icf-employee");
        },
        printIcfEmployee(){
            if(this.hasNoEmployeeSelected){
                this.submitted = true;
                return;
            }
            this.$emit('printIcfEmployee', { id: this.employeeId, name: this.employeeName, printOpts: this.printOpts });
        },
        getLocation() {
            this.$refs.location.getData(this.$store.state.data.selectedCampus.id);
            this.$bvModal.show("icf-location");
        },
        dropLocation(data) {
            this.locationId = data.location.id;
            this.locationName = data.location.location;
            this.$bvModal.hide("icf-location");
        },
        printIcfLocation(){
            if(this.hasNoLocationSelected){
                this.submitted = true;
                return;
            }
            this.$emit('printIcfLocation', { id: this.locationId, name: this.locationName });
        }
    }
}
</script>
<template>
    <b-modal 
        id="icf-modal" 
        title="Print ICF" 
        size="md" 
        title-class="font-18" 
        hide-footer 
        no-close-on-backdrop
    >
        <p class="text-muted mb-0">Print ICF By</p>
        <select class="form-select mt-2 mb-4" v-model="printOpts">
            <option value="1">Current {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</option>
            <option value="2">Employee (PPE)</option>
            <option value="5">Employee (High Value)</option>
            <option value="6">Employee (Low Value)</option>
            <option value="3">Employee (All)</option>
            <option value="4">Location</option>
        </select>
        <b-collapse :visible="printOpts == 1">
            <div v-if="printOpts == 1">
                <button type="button" @click="$emit('printIcf')"
                    class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mb-2">
                    <i class="bx bx-print fs-6 me-2"></i>Print
                </button>
            </div>
        </b-collapse>
        <b-collapse :visible="isICFEmployee">
            <div v-if="isICFEmployee">
            <div class="mb-3">
                <b-input-group>
                <template #append>
                    <b-button 
                        @click="getEmployee" 
                        variant="outline-info"
                    >
                        <i class="mdi mdi-clipboard-text-search-outline"></i>
                    </b-button>
                </template>
                <input 
                    autocomplete="off" 
                    type="text" 
                    disabled 
                    placeholder="Search Employee..." 
                    class="form-control"
                    :class="{ 'is-invalid': submitted && hasNoEmployeeSelected }" 
                    v-model="employeeName" 
                />
                </b-input-group>
                <div v-if="submitted && hasNoEmployeeSelected" class="invalid-feedback">
                <span>This value is required.</span>
                </div>
            </div>
            <button 
                type="button" @click="printIcfEmployee"
                class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mb-2">
                <i class="bx bx-download fs-6 me-2"></i>Print
            </button>
            </div>
        </b-collapse>
        <b-collapse :visible="printOpts == 4">
            <div v-if="printOpts == 4">
                <div class="mb-3">
                    <b-input-group>
                        <template #append>
                            <b-button 
                                @click="getLocation" 
                                variant="outline-info"
                            >
                                <i class="mdi mdi-clipboard-text-search-outline"></i>
                            </b-button>
                        </template>
                        <input 
                            autocomplete="off" 
                            type="text" 
                            disabled 
                            placeholder="Search Location..." 
                            class="form-control"
                            :class="{ 'is-invalid': submitted && hasNoLocationSelected }" 
                            v-model="locationName" 
                        />
                    </b-input-group>
                    <div v-if="submitted && hasNoLocationSelected" class="invalid-feedback">
                        <span>This value is required.</span>
                    </div>
                </div>
                <button type="button" @click="printIcfLocation"
                    class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mb-2">
                    <i class="bx bx-download fs-6 me-2"></i>Print
                </button>
            </div>
            <Employee ref="employee" @dropData="dropEmployee($event)" altId="icf-employee"></Employee>
            <Location ref="location" @dropData="dropLocation($event)" altId="icf-location"></Location>
        </b-collapse>
    </b-modal>
</template>